import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./containers/home/Home";
import TourList from "./containers/tour-list/TourList";
import CreateTour from './containers/create-tour/CreateTour';
import EditTour from './containers/edit-tour/EditTour';
import ViewTour from "./containers/view-tour/ViewTour";
import Login from "./components/common/login/Login"
import ProtectedRoute from "./routes/ProtectedRoute";
import CreateUser from "./components/common/create-user/CreateUser";
import AlertDismissible from "./components/common/alert-message/AlertDismissable";
import Loader from "./components/common/loader/Loader";
import ConfirmModel from "./components/common/confirm-model/ConfirmModel";
import Notification from "./components/common/notification/Notification";
import ManageUser from "./containers/manage-user/ManageUser";
import TourListMap from "./containers/tour-list/TourListMap";
import ManageTeam from './containers/manage-team/ManageTeam';
import TeamTours from "./containers/tour-list/TeamTours";
import TeamToursMap from "./containers/tour-list/TeamToursMap";

function App() {
  return (
    <>
    <Router>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/create-user" component={CreateUser} />
        <ProtectedRoute exact path="/" component={Home} />
        <ProtectedRoute path="/tour-list/:type" component={TourList} />
        <ProtectedRoute path="/team-tours/:teamId" component={TeamTours} />
        <ProtectedRoute path="/create-tour" component={CreateTour} />
        <ProtectedRoute path="/edit-tour/:id" component={EditTour} />
        <ProtectedRoute path="/manage-users" component={ManageUser} />
        <ProtectedRoute path="/manage-teams" component={ManageTeam} />
        <Route path="/view-tour/:id" component={ViewTour} />
        <Route path="/tour-list-map" component={TourListMap} />
        <Route path="/team-tour-map/:teamId" component={TeamToursMap} />
      </Switch>
    
      <AlertDismissible></AlertDismissible>
      <Loader></Loader>
      <ConfirmModel></ConfirmModel>
      <Notification></Notification>
    </Router>
    </>
  );
}

export default App;
